import { config } from '../config';
import { tokenManager } from '../auth/tokenManager';

export const blocksApi = {
  blockUser: async (userId: number, blockedUserId: number): Promise<void> => {
    const response = await tokenManager.makeAuthenticatedRequest(`${config.API_URL}/user/${userId}/block/${blockedUserId}`, {
      method: 'POST',
    });

    if (!response.ok) {
      throw new Error('Failed to block user');
    }
  },

  unblockUser: async (userId: number, blockedUserId: number): Promise<void> => {
    const response = await tokenManager.makeAuthenticatedRequest(`${config.API_URL}/user/${userId}/block/${blockedUserId}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Failed to unblock user');
    }
  },

  getBlocks: async (userId: number): Promise<any[]> => {
    const response = await tokenManager.makeAuthenticatedRequest(`${config.API_URL}/user/${userId}/blocks`);

    if (!response.ok) {
      throw new Error('Failed to fetch blocked users');
    }

    return response.json();
  },
};